// Nuevo módulo Angular para instanciar los NUEVOS componentes que tiene el módulo de Empleados.
// Se importa en app.module.ts

import { NgModule } from "@angular/core";
import { ConfigurarAccesoEmpleadoComponent } from "./acceso/config-acceso.component";
import { BookingStaffSyncDialogComponent } from "./booking-staff-sync-dialog.component";
import { BookingBulkSyncDialogComponent } from "./booking-bulk-sync-dialog.component";
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "../../shared/shared.module";

@NgModule({
    declarations: [
        ConfigurarAccesoEmpleadoComponent,
        BookingStaffSyncDialogComponent,
        BookingBulkSyncDialogComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatProgressSpinnerModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        MatInputModule,
        MatFormFieldModule,
        MatTableModule,
        MatSelectModule,
        MatSnackBarModule,
        MatTooltipModule,
        MatDatepickerModule,
        MatCardModule,
        MatSlideToggleModule,
        MatDialogModule,
        MatTabsModule,
        MatCheckboxModule,
        SharedModule
    ],
    providers: []
})
export class EmployeesModule { }
